enum PortalAuthDialogFields {
	ENABLED = "enabled",
	ANONYMOUS = "anonymous",
	INACTIVITY = "inactivity",
	AUTO_REFRESH = "auto_refresh"
}

export default PortalAuthDialogFields;